import React from 'react'
import styles from './styles.css'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import Button from 'orionsoft-parts/lib/components/Button'
import autobind from 'autobind-decorator'
import {withRouter} from 'react-router'

@withMutation(gql`
  mutation createPreparation(
    $preparationName: String
    $organizationId: String
    $clientNames: String
    $clientLFName: String
    $clientLMName: String
    $clientEmail: String
    $clientRut: String
  ) {
    createPreparation(
      preparationName: $preparationName
      organizationId: $organizationId
      clientNames: $clientNames
      clientLFName: $clientLFName
      clientLMName: $clientLMName
      clientEmail: $clientEmail
      clientRut: $clientRut
    ) {
      _id
    }
  }
`)
@withMessage
@withRouter
export default class Save extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    showMessage: PropTypes.func,
    value: PropTypes.object,
    createPreparation: PropTypes.func,
    organizationId: PropTypes.string
  }

  state = {}

  @autobind
  async save() {
    this.setState({loading: true, errorMessages: null})
    const {
      preparationName,
      clientNames,
      clientLFName,
      clientLMName,
      clientEmail,
      clientRut
    } = this.props.value
    try {
      const {createPreparation: {_id: preparationId}} = await this.props.createPreparation({
        preparationName: preparationName,
        clientNames: clientNames,
        clientLFName: clientLFName,
        clientLMName: clientLMName,
        clientEmail: clientEmail,
        clientRut: clientRut,
        organizationId: this.props.organizationId
      })
      this.props.router.push(`/preparation/${preparationId}/documentinformation`)
      this.props.showMessage('Se ha creado la preparación del documento exitosamente!')
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  disabled() {
    const {preparationName, clientNames, clientEmail, clientRut} = this.props.value
    if (!preparationName || !clientNames || !clientEmail || !clientRut) {
      return false
    }
    return true
  }

  render() {
    return (
      <div className={styles.container}>
        <Button onClick={() => this.props.router.push('/securitySatCustom')}>Volver</Button>
        <Button
          primary
          onClick={this.save}
          disabled={!this.disabled()}
          loading={this.state.loading}
        >
          Crear preparacion
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/Create/Save/index.js